'use strict'
import createPageApp from '../common/CreatePageApp'
import DirectoryService from '../endpoints/DirectoryService'
import axios from 'axios'
import Typeahead from '../components/TypeAheadComponent.vue'
import StateInput from '../components/StateLovComponent.vue'
import SportInput from '../components/SportLovComponent.vue'
import OrgAdminService from '../endpoints/admin/OrgAdminService'



document.addEventListener('DOMContentLoaded', function () {
  sessionStorage.removeItem('listType')
  sessionStorage.removeItem('listDescription')

  createPageApp({

    data: () => ({
      searchUrl: DirectoryService.getOrgSearchEndPoint(),
      search: {
        division: '',
        state: '',
        sportCode: ''
      },
      searchError: ''
    }),
    components: {
      'typeahead': Typeahead,
      'state-input': StateInput,
      'sport-input': SportInput
    },
    methods: {
      selectItem: function (data) {
        if (data.deactive === 'Y') {
          window.location.href = OrgAdminService.getMobyAdminEndPoint(data.orgId)
        } else {
          window.location.href = DirectoryService.getOrgDetailEndPoint() + '?id=' + data.orgId
        }
      },
      advanceSearch: function () {
        if (this.search.division === '' && this.search.state === '' && this.search.sportCode === '') {
          this.searchError = 'Please select a Division, State, or Sport to continue.'
        } else {
          let params = '?type=12'
          if (this.search.division && this.search.division.length > 0) {
            params += '&division=' + this.search.division
          }
          if (this.search.state && this.search.state.length > 0) {
            params += '&state=' + this.search.state
          }
          if (this.search.sportCode && this.search.sportCode.length > 0) {
            params += '&sportCode=' + this.search.sportCode
          }
          window.location.href = DirectoryService.getMemberListEndPoint() + params
        }
      }
    }
  }).mount('#search-panel')
})
